// @ts-check
/** Toggle mobile nav */

if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.mobileNav = function () {
  /**
   * @var {HTMLElement}
   */
  const toggleButton = document.querySelector('[aria-controls="mobile-nav"]');

  /**
   * @var {HTMLElement}
   */
  const backButton = document.querySelector("[data-js-back-button]");

  /**
   * @var {HTMLElement}
   */
  const menuTitle = document.querySelector("[ds-js-menu-title]");

  /**
   * @var {HTMLElement}
   */
  const mobileNav = document.querySelector(
    '[aria-labelledby="mobile-nav-button"]'
  );

  /**
   * @var {NodeListOf<HTMLElement> | undefined}
   */
  const childLinks = mobileNav?.querySelectorAll(".has-children");

  /**
   * @var {NodeListOf<HTMLElement> | undefined}
   */
  const childSections = mobileNav?.querySelectorAll(".mobile-nav__children");

  /**
   * @var {Record<string, string>}
   * A list of classes used as CSS styling hooks
   */
  const classes = {
    isActive: "is-mobile-nav",
    isChildActive: "is-mobile-child-nav",
  };

  /**
   *
   *
   * @return {void}
   */
  const resetMenuTitle = () => {
    menuTitle.innerHTML = menuTitle?.getAttribute("ds-js-menu-title");
  };

  /**
   * Go back to top level nav links e.g. hide children
   *
   * @return {void}
   */
  const handleBack = () => {
    closeAllChildSections();
    document.documentElement.classList.remove(classes.isChildActive);
    toggleButton?.focus();
    resetMenuTitle();
  };

  /**
   * Make sure all buttons/child links are reset (i.e. hidden)
   *
   * @return {void}
   */
  const closeAllChildSections = () => {
    if (childSections) {
      for (let i = 0; i < childSections.length; i++) {
        childSections[i].setAttribute("hidden", "true");
      }
    }

    if (childLinks) {
      for (let i = 0; i < childLinks.length; i++) {
        childLinks[i].setAttribute("aria-expanded", "false");
      }
    }
  };

  /**
   * Close the nav
   *
   * @return {void}
   */
  const close = () => {
    toggleButton?.setAttribute("aria-expanded", "false");
    mobileNav?.setAttribute("hidden", "true");
    document.documentElement.classList.remove(classes.isActive);
    document.documentElement.classList.remove(classes.isChildActive);
    closeAllChildSections();
    resetMenuTitle();
  };

  /**
   * Open the nav
   *
   * @return {void}
   */
  const open = () => {
    toggleButton?.setAttribute("aria-expanded", "true");
    mobileNav?.removeAttribute("hidden");
    document.documentElement.classList.add(classes.isActive);

    // stop the add to bag button sitting on top of the menu
    if (window.AndDaughter.productButtonScroll) {
      window.AndDaughter.productButtonScroll().unstick();
    }

    // Close the open cart
    if (window.AndDaughter.cartDrawer) {
      window.AndDaughter.cartDrawer().close();
    }
  };

  /**
   * Shop/hide top-level mobile nav
   *
   * @param {Event} event
   * @return {void}
   */
  const toggle = (event) => {
    event.preventDefault();
    const isActive =
      toggleButton?.getAttribute("aria-expanded")?.toString() === "true";

    if (isActive) {
      close();
    } else {
      open();
    }
  };

  /**
   * Shop hide child-level mobile nav
   *
   * @param {Event} event
   * @return {void}
   */
  const toggleChild = (event) => {
    event.preventDefault();

    const button = event.currentTarget;
    if (button) {
      const isExpanded = button.getAttribute("aria-expanded");

      const childNav = document.querySelector(
        `#${button.getAttribute("aria-controls")}`
      );

      if (isExpanded === "false") {
        document.documentElement.classList.add(classes.isChildActive);
        menuTitle.innerHTML = button.innerHTML;
      }

      button.setAttribute("aria-expanded", !isExpanded.toString());
      childNav?.toggleAttribute("hidden");
    }
  };

  /**
   * Add and remove event listeners that will trigger actions on the elements
   *
   * @returns {void}
   */
  const addEventListeners = () => {
    toggleButton?.removeEventListener("click", toggle);
    toggleButton?.addEventListener("click", toggle);

    backButton?.removeEventListener("click", handleBack);
    backButton?.addEventListener("click", handleBack);

    if (childLinks) {
      for (let i = 0; i < childLinks.length; i++) {
        childLinks[i].removeEventListener("click", toggleChild);
        childLinks[i].addEventListener("click", toggleChild);
      }
    }
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    addEventListeners();
  };

  return {
    init,
  };
};

window.AndDaughter.mobileNav().init();
